import DocumentWorkspace from './DocumentWorkspace';

export default DocumentWorkspace;
